module.exports = __webpack_public_path__ + "static/media/31JFA11.d080e9e0.jpg";